import { useEffect, useState } from 'react';

import { handleAxiosError } from 'core/notifications';

import axios from '@/util/axios';

export default ({ axiosConfig }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [versions, setVersions] = useState([]);

  const fetchVersions = async () => {
    try {
      setVersions((await axios(axiosConfig)).data.data);
    } catch (error) {
      handleAxiosError(error);
    }

    setIsLoading(false);
  };

  useEffect(() => { fetchVersions(); }, []);

  return { fetchVersions, isLoading, versions };
};
